<template>
    <v-navigation-drawer stateless value="true" dark>
        <v-list>
            <v-list-item to="/">
                <v-list-item-action>
                    <v-icon>home</v-icon>
                </v-list-item-action>
                <v-list-item-title>Главная</v-list-item-title>
            </v-list-item>
            <v-list-item @click="scrollToElement(nav.target)" v-for="nav of navigation" :key="Math.random()">
                <v-list-item-action>
                    <v-icon>{{ nav.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ nav.title }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
    export default {
        name: 'navigationSite',
        data: () => ({
            navigation: [
                {
                    title: 'SEO',
                    icon: 'subject',
                    target: 'seo'
                },
                {
                    title: 'Соц.сети',
                    icon: 'subject',
                    target: 'social'
                },
                {
                    title: 'Слайдер',
                    icon: 'subject',
                    target: 'carousel'
                },
                {
                    title: 'Текстовые блоки',
                    icon: 'subject',
                    target: 'blocks'
                },
                {
                    title: 'Меню',
                    icon: 'subject',
                    target: 'menu'
                },
                {
                    title: 'События и акции',
                    icon: 'subject',
                    target: 'events'
                },
                {
                    title: 'Контакты',
                    icon: 'subject',
                    target: 'contacts'
                },
                // { title: 'Филиалы', icon: 'subject', target: 'branch' }
            ]
        }),
        methods: {
            scrollToElement (target) {
                document.getElementById(target).scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                })
            }
        }
    }
</script>
